import { render } from "./TabBar.vue?vue&type=template&id=f63a2b08&scoped=true"
import script from "./TabBar.vue?vue&type=script&lang=js"
export * from "./TabBar.vue?vue&type=script&lang=js"

import "./TabBar.vue?vue&type=style&index=0&id=f63a2b08&lang=css"
import "./TabBar.vue?vue&type=style&index=1&id=f63a2b08&scoped=true&lang=css"

import exportComponent from "C:\\Users\\MORIMI\\Documents\\git_repositories\\heightlimit_mapbox\\heightlimit_mapbox\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f63a2b08"]])

export default __exports__